import React from "react";
import Logo from "../../assets/Logo.png";

export const Footer = () => {
  return (
    <footer className="bg-white pt-12 md:p-0 p-4">
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 border p-10 rounded-xl">

        {/* Company Info */}
        <div>
          <img src={Logo} alt="Vetri Pipeline Logo" className="w-32 mb-4" />
          <p className="text-gray-600 text-sm leading-relaxed">
            We provide industrial solutions in pipeline systems, boiler erection,
            fabrication, and insulation works with a commitment to quality,
            safety, and performance.
          </p>
        </div>

        {/* Quick Links */}
        <div>
          <h3 className="font-semibold text-gray-900 mb-4">Quick Links</h3>
          <ul className="space-y-2 text-sm text-gray-600">
            <li><a href="/about" className="hover:text-primary-500">About Us</a></li>
            <li><a href="/services" className="hover:text-primary-500">Services</a></li>
            <li><a href="/projects" className="hover:text-primary-500">Projects</a></li>
            <li><a href="/contact-us" className="hover:text-primary-500">Contact Us</a></li>
          </ul>
        </div>

        {/* Services */}
        <div>
          <h3 className="font-semibold text-gray-900 mb-4">Services</h3>
          <ul className="space-y-2 text-sm text-gray-600">
            <li>Pipeline systems</li>
            <li>Insulation work</li>
            <li>Boiler erection</li>
            <li>Industrial services</li>
          </ul>
        </div>

        {/* Address & Contact */}
        <div>
          <h3 className="font-semibold text-gray-900 mb-4">Contact</h3>

          <p className="text-sm text-gray-600 leading-relaxed">
            418/8A, Coimbatore main road, karukkankattur,<br />
            olapalayam post, Perundurai - 638052.
          </p>

          <div className="mt-4 text-sm text-gray-600 space-y-1">
            <p>📞 +91 96888 71444</p>
            <p>✉️ info@vetripipeline.com</p>
          </div>
        </div>

      </div>

      {/* Bottom Bar */}
      <div className="border-t mt-10 py-4 px-6 text-sm text-gray-500">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-3">

          <p>© 2026 Vetri Pipeline Systems Pvt Ltd. All rights reserved.</p>

          <div className="flex items-center gap-6">
            <a href="/privacy" className="hover:text-primary-500">Privacy Policy</a>
            <a href="/terms" className="hover:text-primary-500">Terms of Service</a>
          </div>
        </div>

        <div className="text-center mt-3">
          <a
            href="https://www.santechnovation.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 hover:underline"
          >
            Developed by : SAN Technovation Pvt Ltd.
          </a>
        </div>
      </div>
    </footer>
  );
};